export const asistencia = [
  {
    id: 0,
    titulo: "EMERGENCIAS DOMICILIARIAS",
    subtitulo: "",
    children: 5,
    subtitulo:
      "Tenes disponible un monto de $610.000 anual sin límite de eventos durante las 24 hs, los 365 días del año. Las asistencias cubren hasta $51.000 en mano de obra y $19.000 de materiales.",
  },
  {
    id: 1,
    titulo: "EN CADA DETALLE O DESPERFECTO",
    subtitulo:
      "Siempre hay cosas que se pueden romper o que querés cambiar. Para estas situaciones, tenés un tope de hasta $51.000.- mano de obra + $19.000.- por materiales. Usalos para:",
    children: 4,
    textoBottom: "",
  },
  {
    id: 2,
    titulo: "ASISTENCIA PREVENTIVA",
    subtitulo:
      "¡Mantené tu hogar siempre impecable! Contás con hasta $51.000 + $19.000 de repuestos por evento en mantenimiento preventivo",
    children: 2,
    textoBottom: "",
  },
];
